import React from 'react';
import { connect } from "react-redux";
import StoreActions from "bukku/redux/Store/actions";

const {
    clearPaymentData,
} = StoreActions;

function PendingPayment(props) {
    const { pendingPayment, paymentData, clearPaymentData } = props;

    React.useEffect(() => {
        setTimeout(() => {
            clearPaymentData();
        }, 60000);
    }, [clearPaymentData]);

    if (!pendingPayment)
        return null;

    // when payment gateway is turned off
    if (paymentData.payment_gateway === 'manual') {
        window.open(paymentData.redirect_url, '_self');
        return null;
    }

    // when payment gatway is turned on (even when store setting online payment is off)
    window.open(paymentData.payment_url, '_self');

    return null;
}

export default connect(state => ({
    pendingPayment: state.Store.pendingPayment,
    paymentData: state.Store.paymentData,
}), {
    clearPaymentData,
})(PendingPayment);
